var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: _vm.id } },
    [
      _vm.label
        ? _c("span", [_vm._v(" " + _vm._s(_vm.label) + " ")])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "placeholder__container",
          class: { "has-error": !!_vm.errorMessage }
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchText,
                expression: "searchText"
              }
            ],
            staticClass: "custom-search-text",
            attrs: {
              id: `${_vm.id}-searchmultiselect`,
              name: `${_vm.id}-searchmultiselect`,
              placeholder: _vm.computedPlaceholder,
              type: "text"
            },
            domProps: { value: _vm.searchText },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.searchText = $event.target.value
              }
            }
          }),
          _c("em", {
            staticClass: "fas",
            class: {
              "fa-chevron-down": !_vm.showList,
              "fa-chevron-up": _vm.showList
            },
            staticStyle: { color: "rgba(60,60,60,0.5)", "font-weight": "bold" }
          })
        ]
      ),
      _vm.showList
        ? _c(
            "div",
            { staticClass: "list-options__container" },
            _vm._l(_vm.computedOptions, function(option, index) {
              return _c(
                "div",
                {
                  key: option.id,
                  staticClass: "option-item__container",
                  class: { "multiselect-item-bg__gray": index % 2 === 0 },
                  on: {
                    click: function($event) {
                      return _vm.toggleOption(option)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "custom-control custom-checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: option.checked,
                          expression: "option.checked"
                        }
                      ],
                      staticClass: "custom-control-input",
                      attrs: {
                        id: option.id,
                        name: option.id,
                        type: "checkbox"
                      },
                      domProps: {
                        checked: Array.isArray(option.checked)
                          ? _vm._i(option.checked, null) > -1
                          : option.checked
                      },
                      on: {
                        change: function($event) {
                          var $$a = option.checked,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(option, "checked", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  option,
                                  "checked",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(option, "checked", $$c)
                          }
                        }
                      }
                    }),
                    _c("label", {
                      staticClass: "custom-control-label font regular"
                    })
                  ]),
                  _c("span", [
                    _vm._v(" " + _vm._s(option.name) + " "),
                    option.nameDetail
                      ? _c("b", [_vm._v(_vm._s(option.nameDetail))])
                      : _vm._e()
                  ])
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm.errorMessage
        ? _c("Error", {
            attrs: { message: _vm.errorMessage, variant: "no-border" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }